import { Permisos } from '@/shared/constants/permisos';
import type { TourDefinicion } from '@/features/guia-interactiva/types/guia-interactiva.types';

export const tourRecetTecnologias: TourDefinicion = {
  codigo: 'recet-tecnologias',
  titulo: 'Tecnologías RECET',
  descripcion: 'Gestión de tecnologías sanitarias: crear, importar, exportar y buscar.',
  ruta: '/admin/recet/tecnologias',
  permisoMenu: Permisos.TECNOLOGIAS_MENU,
  pasos: [
    {
      id: 'recet-tecnologias:header',
      selector: '[data-testid="recet-tecnologias.header"]',
      titulo: 'Tecnologías RECET',
      descripcion:
        'Desde aquí gestionas las tecnologías sanitarias, sus secciones y referencias bibliográficas.',
      side: 'bottom',
      align: 'start',
    },
    {
      id: 'recet-tecnologias:boton-importar',
      selector: '[data-testid="recet-tecnologias.boton-importar"]',
      titulo: 'Importar desde Word',
      descripcion:
        'Sube uno o varios .docx. El sistema los analiza, detecta las tecnologías contenidas y te muestra una vista previa para que confirmes cuáles crear. Esta es la vía para registrar nuevas tecnologías.',
      permisoRequerido: Permisos.TECNOLOGIAS_SUBIR,
      side: 'bottom',
      align: 'start',
    },
    {
      id: 'recet-tecnologias:boton-exportar',
      selector: '[data-testid="recet-tecnologias.boton-exportar"]',
      titulo: 'Exportar',
      descripcion:
        'Descarga las tecnologías en formato editable para compartir offline o para respaldo.',
      permisoRequerido: Permisos.TECNOLOGIAS_EXPORTAR,
      side: 'bottom',
      align: 'start',
    },
    {
      id: 'recet-tecnologias:filtros',
      selector: '[data-testid="recet-tecnologias.filtros"]',
      titulo: 'Buscar, filtrar y cambiar de vista',
      descripcion:
        'Busca por nombre, filtra por categoría y alterna entre vista de tarjetas o tabla según prefieras.',
      side: 'bottom',
      align: 'center',
    },
    {
      id: 'recet-tecnologias:listado',
      selector: '[data-testid="recet-tecnologias.listado"]',
      titulo: 'Listado',
      descripcion:
        'Cada tarjeta muestra una tecnología y su estado. Haz clic para abrir el detalle con secciones, referencias y versiones. El listado se muestra en bloques; al final encontrarás un botón "Ver más" para cargar el siguiente cuando haya disponibles.',
      side: 'top',
      align: 'center',
    },
  ],
};
